import { ApplicationType } from '@thesavingsgroup/enums/ApplicationType';
import { isInEnum } from '@thesavingsgroup/utils/isInEnum';
import i18n from 'i18next';
import { StateCreator } from 'zustand';

import { reviewsAssetByBrand, reviewsUrlByBrand } from './constants/reviews';
import { SignUpState } from './types/SignUpState';
import { SignUpStateDependencies } from './types/SignUpStateDependencies';

export const signUpStore =
  ({
    useLeadChannelStore,
    useParameterStore,
  }: SignUpStateDependencies): StateCreator<SignUpState> =>
  () => ({
    firstName: '',
    lastName: '',
    primaryEmailAddress: '',
    primaryPhoneNumber: '',

    computed: {
      get reviewsAsset(): string {
        const {
          computed: { brand },
        } = useLeadChannelStore.getState();

        return reviewsAssetByBrand[brand];
      },
      get reviewsUrl(): string {
        const {
          computed: { brand },
        } = useLeadChannelStore.getState();

        return reviewsUrlByBrand[brand];
      },
      get signUpSubmitButtonText(): string {
        const { applicationType } = useParameterStore.getState();

        const isDefaultButtonText = !isInEnum(applicationType, ApplicationType);

        return isDefaultButtonText
          ? i18n.t('SignUpPage.submitButton.default')
          : i18n.t(`SignUpPage.submitButton.${applicationType}`);
      },
      get signUpSubtitleFirstLineText(): string {
        const { applicationType } = useParameterStore.getState();

        const isDefaultSubtitle = !isInEnum(applicationType, ApplicationType);

        return isDefaultSubtitle
          ? i18n.t('SignUpPage.subtitle.default.firstLine')
          : i18n.t(`SignUpPage.subtitle.${applicationType}.firstLine`);
      },
      get signUpSubtitleSecondLineText(): string {
        const { applicationType } = useParameterStore.getState();

        const isDefaultSubtitle = !isInEnum(applicationType, ApplicationType);

        return isDefaultSubtitle
          ? i18n.t('SignUpPage.subtitle.default.secondLine')
          : i18n.t(`SignUpPage.subtitle.${applicationType}.secondLine`);
      },
      get signUpSubtitleThirdLineText(): string {
        const { applicationType } = useParameterStore.getState();

        const isDefaultSubtitle = !isInEnum(applicationType, ApplicationType);

        return isDefaultSubtitle
          ? i18n.t('SignUpPage.subtitle.default.thirdLine')
          : i18n.t(`SignUpPage.subtitle.${applicationType}.thirdLine`);
      },
      get signUpTitleText(): string {
        const { applicationType } = useParameterStore.getState();

        const isDefaultTitle = !isInEnum(applicationType, ApplicationType);

        return isDefaultTitle
          ? i18n.t('SignUpPage.title.default')
          : i18n.t(`SignUpPage.title.${applicationType}`);
      },
    },
  });
